import type { TFunction } from 'i18next';
import type { Dispensasjon } from '@origo/planregister';
import type { DispensationGroup, DispensationItem } from '../types';
import { dispensasjonTypeLabel } from '../codelists/dispensasjonType';
import { formatDateShortNb } from './formatDate';

function toDispensationItem(d: Dispensasjon, t: TFunction): DispensationItem {
    return {
        id: d.dispensasjonId,
        tittel: d.beskrivelse?.trim() || dispensasjonTypeLabel(d.dispensasjonType, t),
        saksnummer: d.saksaar && d.sakssekvensnummer
            ? `${d.saksaar}/${String(d.sakssekvensnummer).padStart(3, '0')}`
            : '',
        dato: formatDateShortNb(d.vedtaksdato),
    };
}

export function toDispensationGroups(dispensasjoner: Dispensasjon[], t: TFunction): DispensationGroup[] {
    const approved: DispensationItem[] = [];
    const rejected: DispensationItem[] = [];
    for (const d of dispensasjoner) {
        const item = toDispensationItem(d, t);
        if (d.innvilgetDispensasjon) approved.push(item);
        else rejected.push(item);
    }
    return [
        { key: 'approved', count: approved.length, items: approved },
        { key: 'rejected', count: rejected.length, items: rejected },
    ];
}
